export function isValidUrl(url: string): boolean {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // 프로토콜
      '((([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.?)+[a-zA-Z]{2,}|' + // 도메인 이름
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // IPv4 주소
      '(\\:\\d+)?(\\/[-a-zA-Z\\d%_.~+]*)*' + // 포트 및 경로
      '(\\?[;&a-zA-Z\\d%_.~+=-]*)?' + // 쿼리 스트링
      '(\\#[-a-zA-Z\\d_]*)?$',
    'i', // 프래그먼트
  );

  if (!pattern.test(url)) {
    return false;
  }

  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
}
